// src/utils/apiClient.js
//
// Shared axios instance for calls to the Django backend that require a
// Firebase login token. Attaches a fresh Authorization: Bearer <token> to
// every request automatically, so individual pages don't each need to call
// auth.currentUser.getIdToken() themselves (that duplication started with
// the logout call in App.js — this centralizes it before a third place
// needs the same boilerplate).

import axios from 'axios'
import { auth } from '../firebase'

const BASE_URL = process.env.REACT_APP_API_URL

const apiClient = axios.create({
  baseURL: BASE_URL,
})

apiClient.interceptors.request.use(async (config) => {
  const currentUser = auth.currentUser
  if (currentUser) {
    const idToken = await currentUser.getIdToken()
    config.headers.Authorization = `Bearer ${idToken}`
  }
  return config
})

export default apiClient
